import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { usePageTitle } from '../PageTitleContext';
import { CloseIcon, SearchesCIcon } from '../../Static/icons/iconshere';
import { BtnLoading } from '../../animations/BtnLoading';
import { toastError } from '../../utils/toast';
import { CategoryFilterId } from '../../env';
import apiClient from '../../apiClient';
import { CREATE_TAG_CATEGORY, DELATE_TAG_CATEGORY, CATEGORY_CHILDREN_LIST, UPDATE_TAG_CATEGORY } from '../../apiClient/apiEndpoints';
import CategoryItem from './CategoryItem';
import NoDataFound from '../Quiz/NoDataFound/NoDataFound';
import { checkUserAllowPermissions } from '../../utils/common';
import { CONTENT_CATEGORY_CREATE } from '../../constant/Permissions';

let level = 1;

const CategoryMain = () => {
    const configData = useSelector((state) => state.configSlice);
    const [search, setSearch] = useState("");
    const [name, setName] = useState("");
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState({
        action: null,
        type: null,
        status: false,
        id: null,
        parentId: null
    });
    const [deleteModal, setDeleteModal] = useState({
        id: null,
        status: false
    });
    const [loading, setLoading] = useState(false);
    const [fetchLoading, setFetchLoading] = useState(true);
    const [list, setList] = useState([]);
    const { setPageTitle } = usePageTitle();

    const handelOpenModal = (type, parentID) => {

        if (!checkUserAllowPermissions(CONTENT_CATEGORY_CREATE)) return;

        setOpenModal({
            action: "Add new",
            type: type,
            status: true,
            id: null,
            parentId: parentID
        });
    }

    const handelOpenEditModal = (type, name, id, parentID) => {
        if (!checkUserAllowPermissions(CONTENT_CATEGORY_CREATE)) return;
        setOpenModal({
            action: "Edit",
            type: type,
            status: true,
            id: id,
            parentId: parentID
        });
        setName(name);
    }

    const handelOpenDeleteModal = (id) => {
        if (!checkUserAllowPermissions(CONTENT_CATEGORY_CREATE)) return;
        setDeleteModal({
            id: id,
            status: true
        });
    }

    const handelCloseDeleteModal = () => {
        setDeleteModal({
            id: null,
            status: false
        });
    }

    const handelCloseModal = () => {
        setOpenModal({
            action: null,
            type: null,
            status: false,
            id: null,
            parentId: null
        });
        setDeleteModal({
            id: null,
            status: false
        });
        setLoading(false);
        setError(null);
        setName("");
    }

    const getTagCategoryList = async () => {
        try {
            setFetchLoading(true);
            let data = await apiClient.get(`${configData.config.UNO_URL}${CATEGORY_CHILDREN_LIST}/${CategoryFilterId}`);
            setList(data?.children || [])
        } catch (error) {
            console.error(error);
        } finally {
            setFetchLoading(false);
        }
    }

    useEffect(() => {
        setPageTitle("Category Management");
        getTagCategoryList();
    }, []);

    const handleSaveEditTagCategory = async () => {
        if (loading) return;
        try {
            if (name.trim().length === 0) {
                setError("Kindly fill name.");
                setTimeout(() => setError(null), 3500);
                toastError("Kindly fill name.");
                return
            }
            setLoading(true);

            let bodyData = {
                name: name,
                parentId: openModal.parentId,
                id: openModal.id,
            }

            let type = openModal.id ? UPDATE_TAG_CATEGORY : CREATE_TAG_CATEGORY;

            await apiClient.post(`${configData.config.UNO_URL}${type}`, bodyData);
            handelCloseModal();
            getTagCategoryList();

        } catch (error) {
            console.error(error);
            setError("Something went wrong.");
            setTimeout(() => setError(null), 3500);
            toastError("Something went wrong.");
        } finally {
            setLoading(false)
        }
    }

    const handleDeleteTagCategory = async () => {
        if (loading) return;
        try {
            setLoading(true);
            await apiClient.post(`${configData.config.UNO_URL}${DELATE_TAG_CATEGORY}/${deleteModal.id}`);
            handelCloseModal();
            getTagCategoryList();
        } catch (error) {
            console.error(error);
            toastError("Something went wrong.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className='category-main'>
                <div className='row'>
                    <div className='col-md-6'>
                        <form className=" app-search app-search1 d-flex justify-content-start ">
                            {/* <div className="position-relative">
                                <SearchesCIcon />
                                <input placeholder="Search Categories...." className="form-control" type="text" value={search} onChange={(e) => setSearch(e.target.value)} />
                            </div> */}
                        </form>
                    </div>
                    <div className='col-md-6 pe-0  d-flex align-items-center justify-content-end mainbtns'>
                        {checkUserAllowPermissions(CONTENT_CATEGORY_CREATE) && <button className='createbtn' onClick={() => handelOpenModal("category", CategoryFilterId)}>Add Category</button>}
                    </div>
                </div>

                {fetchLoading ?
                    <NoDataFound text="data is fetching." />
                    :
                    list.length === 0 ?
                        <NoDataFound text="No data found." />
                        :
                        list.length > 0 && list.map((item, index) => {
                            return (
                                <CategoryItem level={level} key={item.id} category={item} openModal={handelOpenModal} openEditModal={handelOpenEditModal} openDeleteModal={handelOpenDeleteModal} />
                            )
                        })
                }


            </div>

            <Modal show={openModal.status} size='md' centered onHide={() => handelCloseModal()}  >
                <Modal.Header className='modalheader'>
                    {openModal?.action && (openModal.action)} {openModal?.type && (openModal.type).split(".").join(" ")}
                    <span onClick={() => handelCloseModal()} ><CloseIcon /></span>
                </Modal.Header>
                <Modal.Body className='pb-0'>
                    <div className='row'>
                        <div className='col-12 standardinput' >
                            <label>
                                {openModal?.type && (openModal.type).split(".").join(" ")} Name
                                <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" name="moduleName" id="moduleName" className="input form-control" type="text" />
                                <p className='error'> {error} </p>
                            </label>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className='footerbtn pt-0'>
                    <Button onClick={() => handelCloseModal()}> Cancel </Button>
                    <Button onClick={handleSaveEditTagCategory} > {loading ? <BtnLoading /> : openModal.id ? "Update" : "Add"} </Button>
                </Modal.Footer>
            </Modal>


            <Modal centered show={deleteModal.status} onHide={handelCloseDeleteModal} >
                <Modal.Header className="popupheader delete pt-4">
                    Delete Category
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group pt-4 pb-5 m-0">
                                <p className="popupheading delete p-0 m-0">Do you really want to delete this Category?</p>
                            </div>
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center mt-2 mb-2 footerbtn">
                                    <button onClick={handelCloseDeleteModal}>Cancel</button>
                                    <button onClick={handleDeleteTagCategory} className="ms-3">Delete</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CategoryMain
